var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 3.33329C8.61925 3.33329 7.49996 4.45258 7.49996 5.83329C7.49996 7.214 8.61925 8.33329 9.99996 8.33329C11.3807 8.33329 12.5 7.214 12.5 5.83329C12.5 4.45258 11.3807 3.33329 9.99996 3.33329ZM5.83329 5.83329C5.83329 3.53211 7.69877 1.66663 9.99996 1.66663C12.3011 1.66663 14.1666 3.53211 14.1666 5.83329C14.1666 8.13448 12.3011 9.99996 9.99996 9.99996C7.69877 9.99996 5.83329 8.13448 5.83329 5.83329ZM8.33329 13.3333C7.67025 13.3333 7.03437 13.5967 6.56553 14.0655C6.09668 14.5344 5.83329 15.1703 5.83329 15.8333V17.5C5.83329 17.9602 5.4602 18.3333 4.99996 18.3333C4.53972 18.3333 4.16663 17.9602 4.16663 17.5V15.8333C4.16663 14.7282 4.60561 13.6684 5.38701 12.887C6.16842 12.1056 7.22822 11.6666 8.33329 11.6666H11.6666C12.7717 11.6666 13.8315 12.1056 14.6129 12.887C15.3943 13.6684 15.8333 14.7282 15.8333 15.8333V17.5C15.8333 17.9602 15.4602 18.3333 15 18.3333C14.5397 18.3333 14.1666 17.9602 14.1666 17.5V15.8333C14.1666 15.1703 13.9032 14.5344 13.4344 14.0655C12.9656 13.5967 12.3297 13.3333 11.6666 13.3333H8.33329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a8125898937f7062a212ac90abb6c94f.svg";
export { ForwardRef as ReactComponent };